export const BlobCollectionRecipe = {
    $type$: 'Recipe',
    name: 'BlobCollection',
    rule: [
        {
            itemprop: 'name',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'blobs',
            itemtype: {
                type: 'array',
                item: { type: 'referenceToObj', allowedTypes: new Set(['BlobDescriptor']) }
            }
        }
    ]
};
export const BlobDescriptorRecipe = {
    $type$: 'Recipe',
    name: 'BlobDescriptor',
    rule: [
        {
            itemprop: 'data',
            itemtype: { type: 'referenceToBlob' }
        },
        {
            itemprop: 'lastModified',
            itemtype: { type: 'number' }
        },
        {
            itemprop: 'name',
            itemtype: { type: 'string' }
        },
        {
            // size in bytes
            itemprop: 'size',
            itemtype: { type: 'number' }
        },
        {
            // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types#Types
            itemprop: 'type',
            itemtype: { type: 'string' }
        }
    ]
};
export const ClobDescriptorRecipe = {
    $type$: 'Recipe',
    name: 'ClobDescriptor',
    rule: [
        {
            itemprop: 'data',
            itemtype: { type: 'referenceToClob' }
        },
        {
            itemprop: 'lastModified',
            itemtype: { type: 'number' }
        },
        {
            itemprop: 'name',
            itemtype: { type: 'string' }
        },
        {
            // size in bytes
            itemprop: 'size',
            itemtype: { type: 'number' }
        },
        {
            // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types#Types
            itemprop: 'type',
            itemtype: { type: 'string' }
        }
    ]
};
const BlobRecipes = [BlobCollectionRecipe, BlobDescriptorRecipe, ClobDescriptorRecipe];
export default BlobRecipes;
//# sourceMappingURL=BlobRecipes.js.map